import { createPortal } from "react-dom";
import { AiOutlinePaperClip } from "react-icons/ai";
import { BiPaperPlane } from "react-icons/bi";
import { TiLocationArrow } from "react-icons/ti";
import { Route, Router } from "react-router-dom";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import { useEffect, useState } from "react";
import sendRequest from "hooks/useAxios";
export default function StatusReportModal({
  selectedItem,
  pageType,
  chats,
  // chatList,
  // setChats,
  setUpdater
}) {
  // timestamo
  const timestampToDate = time => {
    if (time != "") {
      const a = time * 1000;
      const date = new DateObject({ date: a, calendar: persian });
      return date.format();
    }
  };
  const [addChat, setAddChat] = useState({
    chattxt: "",
    Order_id: "",
    mtm: "",
    file: ""
  });
  const [displayTxt, setDisplayTxt] = useState("d-none");

  const addChats = () => {
    const timestamp = Math.floor(new Date().getTime() / 1000);
    if (addChat.chattxt || addChat.file) {
      setDisplayTxt("d-none");
      sendRequest("addchat", {
        chattxt: addChat.chattxt,
        mtm: timestamp,
        order_id: selectedItem.id,
        files: addChat.file
      }).then(({ data }) => {
        if (data.status == 1) {
          setUpdater(prev => {
            return !prev;
          });
          setAddChat(prev => {
            return { ...prev, chattxt: "" };
          });
        }
      });
    } else {
      setDisplayTxt("d-block");
    }
  };
  // list of chat

  const modalVar = (
    <div className="modal fade" id="StatusReportModal">
      <div className="modal-dialog modal-lg ">
        {Object.keys(selectedItem).length && (
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              borderRadius: "15px",
              padding: "30px"
            }}
          >
            <div className="row p-4">
              <div className="modal-header">
                <div className="col-11">
                  <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                    تاریخچه ی پیام ها
                  </span>
                </div>
                <div className="col-1">
                  <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      style={{
                        border: "1px solid black",
                        borderRadius: "50%",
                        color: "black !important"
                      }}
                    ></button>
                  </span>
                </div>
              </div>
              <div className="d-flex flex-column">
                {selectedItem.chats.map(value => {
                  return (
                    <ItemMessage
                      messageType={value.type}
                      accountType={pageType}
                      time={timestampToDate(value.mtm)}
                      message={value.chattxt}
                      url={value.url}
                    ></ItemMessage>
                  );
                })}
              </div>
            </div>

            <div className=" row modal-footer">
              <div className="col-2 justify-content-start">
                <span
                  style={{
                    borderRadius: "70%",
                    backgroundColor: "#33aff5",
                    direction: "rtl ",
                    color: "white",
                    padding: "0px 10px",
                    fontSize: "25px",
                    transform: "rotate(-360deg) !important"
                  }}
                >
                  <TiLocationArrow onClick={() => addChats()}></TiLocationArrow>
                </span>
              </div>
              <div className="col-9 d-flex justify-content-end   ">
                <span className="w-100">
                  <textarea
                    className="form-control"
                    type="text"
                    placeholder="...پیام خودرا وارد کنید"
                    style={{
                      borderStyle: "none",
                      direction: "ltr"
                    }}
                    value={addChat.chattxt}
                    onChange={e => {
                      setAddChat(prev => {
                        return { ...prev, chattxt: e.target.value };
                      });
                    }}
                  ></textarea>
                </span>
                <label htmlFor="modal-chat">
                  <span
                    style={{ fontSize: "20px", transform: "rotate(140deg)" }}
                  >
                    <AiOutlinePaperClip></AiOutlinePaperClip>
                  </span>
                </label>
                <input
                  id="modal-chat"
                  className="d-none"
                  type="file"
                  onChange={e => {
                    setAddChat(prev => {
                      return { ...prev, file: e.target.files[0] };
                    });
                  }}
                />
              </div>
            </div>
            <div
              className={`${displayTxt} text-danger mx-auto`}
              style={{ fontSize: "13px" }}
            >
              متن پیام یا تصویر باید وارد شود.
            </div>
          </div>
        )}
      </div>
    </div>
  );
  return createPortal(modalVar, document.querySelector("#modals"));
}

export function ItemMessage({ accountType, messageType, time, message, url }) {
  if (accountType != messageType) {
    return (
      <div
        className="d-flex-column justify-content-end "
        style={{ marginTop: "10px", position: "relative", alignSelf: "end" }}
      >
        <div
          style={{
            backgroundColor: "#1a97cd",
            position: "absolute",
            width: "15px",
            height: "15px",
            left: "-6px",
            transform: "translateY(15px)  rotate(140deg)"
          }}
        ></div>
        <div
          style={{
            backgroundColor: "#1a97cd",
            color: "white",
            direction: "ltr",
            padding: "10px",
            borderRadius: "6px"
          }}
        >
          {message == "" ? (
            <a
              href={`http://oilb.tatdemo.ir/api/${url}`}
              className="text-light"
              target="_blank"
            >
              http://oilb.tatdemo.ir/api/${url}
            </a>
          ) : (
            message
          )}
          {/* {message}/{accountType}/{messageType} */}
        </div>
        <div style={{ color: "#1a97cd" }}>{time}</div>
      </div>
    );
  } else {
    return (
      <div
        className="d-flex-column justify-content-start"
        style={{
          marginTop: "10px",
          width: "fit-content",
          position: "relative",
          alignSelf: "start"
        }}
      >
        <div
          style={{
            backgroundColor: "#1a97cd",
            position: "absolute",
            width: "15px",
            height: "15px",
            right: "-6px",
            transform: "translateY(15px) rotate(140deg)"
          }}
        ></div>
        <div
          style={{
            backgroundColor: "#1a97cd",
            color: "white",
            padding: "10px",
            borderRadius: "6px"
          }}
        >
          {message == "" ? (
            <a
              href={`http://oilb.tatdemo.ir/api/${url}`}
              className="text-light"
              target="_blank"
            >
              http://oilb.tatdemo.ir/api/${url}
            </a>
          ) : (
            message
          )}
          {/* {message}/{accountType}/{messageType} */}
        </div>
        <div style={{ color: "#1a97cd", direction: "rtl" }}>{time}</div>
      </div>
    );
  }
}

//مودال صورت وضعیت
// import { createPortal } from "react-dom";
// export default function StatusReportModal({ selectedItem }) {
//   const modalVar = (
//     <div className="modal fade" id="StatusReportModal">
//       <div className="modal-dialog modal-lg ">
//         {Object.keys(selectedItem).length && (
//           <div
//             className="modal-content"
//             style={{
//               backgroundColor: "#dddbdc",
//               borderRadius: "15px",
//               padding: "30px",
//             }}
//           >
//             <div className="row p-4">
//               <div className="col-11">
//                 <span style={{ fontWeight: "bold", fontSize: "15px" }}>
//                   تاریخچه ی پیام ها
//                 </span>
//               </div>
//               <div className="col-1">
//                 <span style={{ fontWeight: "bold", fontSize: "15px" }}>
//                   <button
//                     type="button"
//                     class="btn-close"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     style={{
//                       border: "1px solid black",
//                       borderRadius: "50%",
//                       color: "black !important",
//                     }}
//                   ></button>
//                 </span>
//               </div>
//             </div>
//             {selectedItem.statusReport.map((value) => {
//               return (
//                 <ItemStatusReportModal
//                   type={value.type}
//                   date={value.date}
//                   MessageText={value.MessageText}
//                   img={value.img}
//                 ></ItemStatusReportModal>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </div>
//   );
//   return createPortal(modalVar, document.querySelector("#modals"));
// }
// export function ItemStatusReportModal({ date, img, MessageText, type }) {
//   return (
//     <div>
//       <div className="row p-4 mt-3 bg-white" style={{ borderRadius: "10px" }}>
//         <div style={{ textAlign: "center", fontSize: "14px" }}>
//           {type == true ? (
//             <div>
//               <span>{`شمادر تاریخ`}</span>
//               <span style={{ color: "#f63644" }}>{date}</span>
//               <span> پیشنهادفروشگاه را</span>
//               <span>
//                 <a
//                   style={{
//                     color: "#f63644",
//                     marginRight: "3px",
//                     marginLeft: "3px",
//                   }}
//                 >
//                   رد
//                 </a>
//                 کردید
//               </span>
//             </div>
//           ) : (
//             <div>
//               <span>{`شمادر تاریخ`}</span>
//               <span style={{ color: "#f63644" }}>{date}</span>
//               <span> پیشنهادفروشگاه را</span>
//               <span>
//                 <a
//                   style={{
//                     color: "#2b9244",
//                     marginRight: "3px",
//                     marginLeft: "3px",
//                   }}
//                 >
//                   قبول
//                 </a>
//                 کردید
//               </span>
//             </div>
//           )}
//         </div>
//         <div className="row">
//           <div className="col-10 mt-3">
//             <span>
//               <strong>متن پیام</strong>
//               <strong style={{ marginLeft: "8px", marginRight: "8px" }}>
//                 :
//               </strong>
//               <span> {MessageText}</span>
//             </span>
//             <span style={{ fontSize: "14px" }}></span>
//           </div>
//           <div className="col-2 mt-3">
//             <img style={{ width: "100px", height: "90px" }} src={img}></img>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
